import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { connect } from 'react-redux';
import { Input, Select, FallbackImage, Render, Button, PaperClip, DatePicker, Viewer } from 'components';
import { RootState } from 'reducers';
import { Globals, Constants } from 'utils';
import { PublicService, DriverService } from 'services';
import { UserIcon, PasswordActive, PasswordInactive, LogoutIcon, UploadIcon, EyeIcon, CheckCircleIcon, CancelCircleIcon } from 'assets/icons';
import moment from 'moment';

interface Props extends RootState, RouteComponentProps<any> {
	dispatch: any
}

const STEPS = {
	DATA: 1,
	FILES: 2
}

const files = [
	{
		name: 'Certificado de Salud',
		field: 'medical_certificate'
	},
	{
		name: 'Certificado de manipulación de alimentos',
		field: 'food_handling'
	},
	{
		name: 'Licencia de conducir',
		field: 'license'
	},
	{
		name: 'RIF',
		field: 'rif'
	},
	{
		name: 'Cédula',
		field: 'document_file'
	}
]

class Invitations extends React.Component<Props> {

	state: any = {
		visible: false,
		form: {
			photo_file: null,
			name: '',
			password: '',
			birth_city: '',
			city: '',
			phone: '',
			gender: '',
			birthdate: '',
			document: '',
			email: '',
			owner: Constants.DRIVER_OWNER.NO,
			nationality_id: Constants.NATIONALITIES.V,
			working_since: '',
			medical_certificate: {
				expiration_date: '',
				file: ''
			},
			food_handling: {
				expiration_date: '',
				file: ''
			},
			license: {
				expiration_date: '',
				file: ''
			},
			rif: {
				expiration_date: '',
				file: ''
			},
			document_file: {
				expiration_date: '',
				file: ''
			}
		},
		activePassword: false,
		step: STEPS.DATA,
		nationalities: [],
		visible_image: false,
		file: null
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: this.props.user ? 'Finalizar registro' : 'Invitación',
				onBack: null
			}
		});

		this.props.dispatch({
			type: 'SET_SUBHEADER',
			payload: {
				title: ''
			}
		});

		this.load();
	}

	load = async () => {
		const res: any = await PublicService.invitations.get({
			code: this.props.match.params.code
		});
		if (res.invitation) {
			this.setState({
				visible: true,
				nationalities: res.nationalities || [],
				form: {
					...this.state.form,
					name: res.invitation?.name || '',
					phone: res.invitation?.phone || '',
					city: res.invitation?.city || '',
					email: res.invitation?.email || '',
				}
			});
		}
		else if (this.props.user?.level_id == Constants.LEVELS.DRIVER && !this.props.user?.register_finished) {
			this.setState({
				visible: true,
				step: STEPS.FILES
			});
		}
		else {
			if (this.props.match.params.code)
				Globals.showError("Lo sentimos, la invitación no esta disponible");
			this.props.history.replace('/');
		}
	}

	submit = async () => {
		if (!this.state.form.photo_file) {
			Globals.showError("Por favor, suba una foto de perfil");
			return;
		}

		const res: any = await PublicService.invitations.save({
			code: this.props.match.params.code,
			...this.state.form,
			// @ts-ignore
			photo_file: this.state.form.photo_file?.value,
			hasFile: true,
			birthdate: this.state.form.birthdate && moment(this.state.form.birthdate).format('YYYY-MM-DD'),
			working_since: this.state.form.working_since && moment(this.state.form.working_since).format('YYYY-MM-DD'),
		});
		if (res.user) {
			this.setState({
				step: STEPS.FILES
			});
			await this.props.dispatch({
				type: 'SET_ACCESS_TOKEN',
				payload: res.access_token
			});
			await this.props.dispatch({
				type: 'SET_USER',
				payload: res.user
			});
			this.props.history.replace('/driver-finish-register');
		}
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	logout = () => {
		Globals.confirm('¿Desea cerrar sesión? Para finalizar el registro deberá iniciar sesión.', () => {
			this.props.dispatch({ type: 'SET_USER', payload: null });
			this.props.dispatch({ type: 'SET_ACCESS_TOKEN', payload: null });
			this.props.history.replace('/login');
			Globals.quitLoading();
		});
	}

	finish = async () => {
		const { form } = this.state;

		let files_required = ['medical_certificate','rif','license','document_file'];
		for (let i = 0; i < files_required.length; i++) {
			// @ts-ignore
			if (!this.state.form[files_required[i]].file) {
				let _document = '';
				switch(files_required[i]) {
					case 'medical_certificate': _document = 'Certificado de Salud'; break;
					case 'rif': _document = 'RIF'; break;
					case 'license': _document = 'Licencia de Conducir'; break;
					case 'document_file': _document = 'Cédula'; break;
				}

				Globals.showError(`El documento ${ _document } es requerido`);
				return;
			}
		}

		const res: any = await PublicService.invitations.finishRegister({
			// @ts-ignore
			medical_certificate: this.state.form?.medical_certificate?.file?.value,
			medical_certificate_expiration_date: this.state.form?.medical_certificate?.expiration_date && moment(this.state.form?.medical_certificate?.expiration_date).format('YYYY-MM-DD'),
			// @ts-ignore
			rif: this.state.form?.rif?.file?.value,
			rif_expiration_date: this.state.form?.rif?.expiration_date && moment(this.state.form?.rif?.expiration_date).format('YYYY-MM-DD'),
			// @ts-ignore
			food_handling: this.state.form?.food_handling?.file?.value,
			food_handling_expiration_date: this.state.form?.food_handling?.expiration_date && moment(this.state.form?.food_handling?.expiration_date).format('YYYY-MM-DD'),
			// @ts-ignore
			license: this.state.form?.license?.file?.value,
			license_expiration_date: this.state.form?.license?.expiration_date && moment(this.state.form?.license?.expiration_date).format('YYYY-MM-DD'),
			// @ts-ignore
			document_file: this.state.form?.document_file?.file?.value,
			document_file_expiration_date: this.state.form?.document_file?.expiration_date && moment(this.state.form?.document_file?.expiration_date).format('YYYY-MM-DD'),
			user_id: this.props.user?.id,
			hasFile: true
		});
		if (res.user) {
			await this.props.dispatch({
				type: 'SET_USER',
				payload: res.user
			});
			this.props.history.replace('/');
		}
	}

	viewFile = (item: any) => {
		if (item?.value?.type == 'application/pdf') {
			const url = URL.createObjectURL(item?.value);
			window.open(url, '_blank');
		}
		else {
			this.setState({
				visible_image: true,
				file: item?.dataURL
			});
		}
	}

	onChangeFile = async (file: any, target: string) => {
		const onError = (msg: string) => {
			Globals.showError(msg);
			return false;
		}

		let document_type_id = null;
		let ignore_document_expiration = false;

		switch(target) {
			case 'rif': 
				document_type_id = Constants.BRAVEALO_DOCUMENT_TYPES.RIF; 
				ignore_document_expiration = true;
			break;

			case 'food_handling': 
				document_type_id = Constants.BRAVEALO_DOCUMENT_TYPES.FOOD_HANDLING; 
				ignore_document_expiration = true;
			break;

			case 'medical_certificate': 
				document_type_id = Constants.BRAVEALO_DOCUMENT_TYPES.HEALTH_CERTIFICATE; 
			break;

			case 'document_file': 
				document_type_id = Constants.BRAVEALO_DOCUMENT_TYPES.ID; 
				ignore_document_expiration = true;
			break;
			
			case 'license': 
				document_type_id = Constants.BRAVEALO_DOCUMENT_TYPES.DRIVER_LICENSE; 
			break;
		}

		const res: any = await DriverService.readDocument({
			hasFile: true,
			photo: file.value,
			driver_id: this.props.user?.id,
			document_type_id,
			ignore_document_expiration: ignore_document_expiration || ''
		});
		if (!res.result || !res.expiration_date) {
			this.setState({
				form: {
					...this.state.form,
					[target]: {
						...this.state.form[target],
						file: null
					}						
				}
			});
			return onError('El documento cargado no corresponde al formato requerido o no es válido. Por favor, sube el documento solicitado para continuar.');
		}
		else {
			this.setState({
				form: {
					...this.state.form,
					[target]: {
						...this.state.form[target],
						file,
						expiration_date: res.expiration_date ? moment(res.expiration_date).toDate() : ''
					}
				}
			});
		}
	}

	render() {
		const { visible, form, step, visible_image } = this.state;
		// @ts-ignore
		const photo_blob = form.photo_file ? URL.createObjectURL(form.photo_file?.value) : null;

		return (
			<div id="public-invitation">
				<Viewer
			      visible={ visible_image }
			      onClose={ () => this.setState({ visible_image: false }) }
			      images={ [{ src: this.state.file }] }
			    />

				{
					visible && (
						<>
							<div className="container-white">
								{
									step == STEPS.DATA && (
										<>
											<div className="row">
												<div className="col-md-6">
													<div className="text-center" style={{ marginBottom: '20px' }}>
														<PaperClip
															className="btn-icon"
									                        value={''}
									                        onChange={(e: any) => {
									                        	this.setState({
									                              form: {
									                              	...this.state.form,
									                              	photo_file: e.target
									                              }
									                            });
									                        }}>
																<div className="photo-wrapper-file">
																	<FallbackImage
																		// @ts-ignore
																		src={photo_blob}
																		placeholder={UserIcon}
																		className="fb-img"
																		placeholderClassName="fb-img-placeholder"
																	/>
																</div>
														</PaperClip>
													</div>

													<div className="input-group">
														<Input
															label="Nombre"
															value={form?.name}
															name="name"
															onChange={(e: any) => this.change(e)}
															notMui
														/>
													</div>
													<div className="input-group">
														<Select
															name="owner"
															label="Camión Propio"
															onChange={ (e: any) => this.change(e) }
															value={ form.owner }
															options={ [
																{ value: Constants.DRIVER_OWNER.YES.toString(), label: 'Si' },
																{ value: Constants.DRIVER_OWNER.NO.toString(), label: 'No' },
															] }
														/>
													</div>
													<div className="input-group" style={{ alignItems: 'center' }}>
														<Input
															type={ this.state.activePassword ? 'text' : 'password' }
															label="Contraseña"
															value={form?.password}
															name="password"
															onChange={ (e: any) => this.change(e) }
															notMui
														/>
														<div className="input-group-prepend password-view" onClick={ () => {
															this.setState({
																activePassword: !this.state.activePassword
															});
														} }>
															<img src={ this.state.activePassword ? PasswordActive : PasswordInactive } />
														</div>
													</div>
													<div className="input-group">
														<DatePicker
								                          label="Trabajando desde el"
								                          placeholder="Fecha"
								                          maxDate={moment().toDate()}
								                          onChange={(date: string) => {
								                            this.setState({
								                              form: {
								                              	...this.state.form,
								                              	working_since: date
								                              }
								                            });
								                          }}
								                          value={form?.working_since}
								                        />
													</div>
													<div className="input-group">
														<Input
															type="number"
															label="Documento de Identidad"
															value={form?.document}
															name="document"
															onChange={(e: any) => this.change(e)}
															notMui
														/>
													</div>
												</div>
												<div className="col-md-6">
													<div className="input-group">
														<Input
															label="Email"
															value={form?.email}
															name="email"
															onChange={(e: any) => this.change(e)}
															notMui
														/>
													</div>
													<div className="input-group">
														<DatePicker
								                          label="Fecha de nacimiento"
								                          placeholder="Fecha"
								                          maxDate={moment().toDate()}
								                          onChange={(date: string) => {
								                            this.setState({
								                              form: {
								                              	...this.state.form,
								                              	birthdate: date
								                              }
								                            });
								                          }}
								                          value={form?.birthdate}
								                        />
													</div>
													<div className="input-group">
														<Select
															name="nationality_id"
															label="Nacionalidad"
															onChange={ (e: any) => this.change(e) }
															value={ form.nationality_id }
															options={ this.state.nationalities.map((item: any) => {
																return {
																	value: item.id,
																	label: item.name
																}
															}) }
														/>
													</div>
													<div className="input-group">
														<Input
															label="Lugar de Nacimiento"
															value={form?.birth_city}
															name="birth_city"
															onChange={(e: any) => this.change(e)}
															notMui
														/>
													</div>
													<div className="input-group">
														<Select
															label="Sexo"
															name="gender"
															onChange={ (e: any) => this.change(e) }
															value={ form.gender }
															options={ [
																{ value: 'M', label: 'Masculino' },
																{ value: 'F', label: 'Femenino' },
															] }
														/>
													</div>
													<div className="input-group">
														<Input
															type="number"
															maxLength={ 11 }
															label="Teléfono"
															value={form?.phone}
															name="phone"
															onChange={(e: any) => this.change(e)}
															notMui
														/>
													</div>
													<div className="input-group">
														<Input
															label="Zona donde reside"
															value={form?.city}
															name="city"
															onChange={(e: any) => this.change(e)}
															notMui
														/>
													</div>
												</div>
											</div>
											<div className="text-right" style={{ marginTop: '20px' }}>
												<Button color="primary rounded-full" onClick={() => this.submit()}>
													Siguiente
												</Button>
											</div>
										</>
									)
								}

								{
									step == STEPS.FILES && (
										<>
											<div className="text-right">
												<button className="close-session" onClick={this.logout}>
													<img src={LogoutIcon} alt="Close" />
												</button>
											</div>
											<p className="title-documents">Documentos y certificaciones</p>
											<div className="row">
												{
													files?.map((item) => {
														return (
															<div className="col-md-6">
																<div className="document-item">
																	<div className="row">
																		<div className="col-md-8">
																			<div className="container-title-document">
																				<p>{ item.name }</p>
																				<img className={ form[item.field].file ? 'active' : '' } src={ form[item.field].file ? CheckCircleIcon : CancelCircleIcon } />
																			</div>
																		</div>
																		<div className="col-md-4">
																			<PaperClip
																				className="btn-icon"
														                        successText="Adjuntar"
														                        pendingText="Adjuntar"
														                        value={''}
														                        formats={['png','jpg','pdf','jpeg']}
														                        onChange={(e: any) => {
														                        	this.onChangeFile(e.target,item.field);
														                        }}>
														                        Adjuntar
																				<img src={ UploadIcon } />
														                    </PaperClip>
																			<button className="btn btn-icon" disabled={ !this.state.form[item.field]?.file } onClick={ () => {
																				this.viewFile(this.state.form[item.field].file);
																			} }>
																				Ver
																				<img src={ EyeIcon } />
																			</button>
																		</div>
																	</div>

																	<DatePicker
											                          label="F. Expiración"
											                          placeholder="--_--"
											                          minDate={moment().add(1,'day').toDate()}
											                          disabled={ true }
											                          onChange={(expiration_date: string) => {
											                            // this.setState({
											                            //   form: {
											                            //   	...this.state.form,
											                            //   	[item.field]: {
											                            //   		...this.state.form[item.field],
											                            //   		expiration_date
											                            //   	}
											                            //   }
											                            // });
											                          }}
											                          value={this.state.form[item.field].expiration_date}
											                        />
											                    </div>
															</div>
														)
													})
												}
											</div>
											<div className="text-right" style={{ marginTop: '20px' }}>
												<div className="row" style={{ display: 'inline-flex' }}>
													<div className="col-md-6">
														<Button color="primary rounded-full" onClick={() => this.finish()}>
															Guardar
														</Button>
													</div>
												</div>
											</div>
										</>
									)
								}								
							</div>
						</>
					)
				}
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(Invitations);